import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { polishExtendedNameRegex } from 'src/shared/regex';

export const labelRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    required: true,
    message: t('Please enter correct label'),
    pattern: polishExtendedNameRegex,
  });
};
